import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'flow-no-data',
  templateUrl: './no-data.component.html',
  styleUrls: ['./no-data.component.scss'],
  imports: [CommonModule, TranslateModule],
  standalone: true,
})
export class NoDataComponent implements OnInit {
  @Input() label: string = '';
  @Input() title: string = 'global.noDataSelected';
  @Input() height: 'sm' | 'lg' | 'auto' = 'auto';
  heightClass: string = '';

  ngOnInit() {
    this.setStyle();
  }

  setStyle() {
    const styles = {
      sm: 'h-28',
      lg: 'h-48',
      auto: 'h-full',
    };

    this.heightClass = `${styles[this.height]}`;
  }
}
